import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

const Alert = ({ error, warning, success, children }) => {
    const classAlert = clsx("alert", {
        "alert--error": error,
        "alert--warning": warning,
        "alert--success": success,
    });

    return <div className={classAlert}>{children}</div>;
};

Alert.propTypes = {
    children: PropTypes.node,
    error: PropTypes.bool,
    warning: PropTypes.bool,
    success: PropTypes.bool,
};

Alert.defaultProps = {
    children: "",
    error: true,
    warning: false,
    success: false,
};

export default Alert;
